import React from 'react'
import {
  Facebook,
  Twitter,
  Instagram,
  Chat,
  QuestionmarkRounded,
} from '@ticketswap/comets'
import { getLinkProps } from '~/utils'

export const items = {
  primary: [
    { title: 'footer.primary.home', ...getLinkProps('HOME') },
    {
      title: 'footer.primary.howItWorks',
      ...getLinkProps('HOW_DOES_IT_WORK'),
    },
    {
      title: 'footer.primary.aboutUs',
      ...getLinkProps('CONTENT', { slug: 'about-us' }),
    },
    {
      title: 'generic.blog',
      ...getLinkProps('BLOG'),
    },
    {
      title: 'footer.primary.jobs',
      url: 'https://jobs.ticketswap.com/',
    },
    {
      title: 'footer.primary.partners',
      ...getLinkProps('PARTNERS'),
    },
    {
      title: 'footer.primary.contact',
      ...getLinkProps('HELP'),
    },
  ],
  legal: [
    {
      title: 'footer.legal.conditions',
      ...getLinkProps('CONTENT', { slug: 'conditions' }),
    },
    {
      title: 'footer.legal.privacy',
      ...getLinkProps('CONTENT', { slug: 'privacy' }),
    },
    {
      title: 'footer.legal.responsibleDisclosure',
      ...getLinkProps('CONTENT', { slug: 'responsible-disclosure' }),
    },
  ],
  social: [
    {
      title: 'Facebook',
      icon: <Facebook size={24} />,
      url: 'https://www.facebook.com/TicketSwap',
    },
    {
      title: 'Twitter',
      icon: <Twitter size={24} />,
      url: 'https://www.twitter.com/TicketSwap',
    },
    {
      title: 'Instagram',
      icon: <Instagram size={24} />,
      url: 'https://www.instagram.com/ticketswap',
    },
  ],
  help: [
    {
      title: 'footer.help.contact',
      icon: <Chat size={24} />,
      ...getLinkProps('HELP'),
    },
    {
      title: 'footer.help.faq',
      icon: <QuestionmarkRounded size={24} />,
      ...getLinkProps('HELP'),
    },
  ],
  locales: [
    { name: 'Deutsch', value: 'de-DE' },
    { name: 'English', value: 'en' },
    { name: 'Español', value: 'es-ES' },
    { name: 'Français', value: 'fr-FR' },
    { name: 'Magyar', value: 'hu-HU' },
    { name: 'Nederlands', value: 'nl-NL' },
  ],
}
